import React from 'react';
import styled from 'styled-components';
import { Card, Col, Row, Form, Input, Button, Layout, Spin } from 'antd';
import loginBG from '../Login/images/bg.jpg';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
const styles = {
	error: {
		textAlign: 'center',
		margin: '1rem',
		fontSize: '22px',
		fontWeight: 'bold',
		color: '#cf4500',
	},
	success: {
		textAlign: 'center',
		margin: '1rem',
		fontSize: '22px',
		fontWeight: 'bold',
		color: '#22BB33',
	},
	login:{
		textAlign: 'center',
		margin: '1rem',
		fontSize: '22px',
		color: 'blue',
	}
};

const ResetExpireError = ({resp}) => {
    const { Background } = StyledComponents;
    return (
        <Background justify='center' align='middle'>
				<Col xs={22} sm={16} md={12} lg={10} xl={8} xxl={7}>
					<Card className='change-pass-link-error-card'>
						{
							(resp || !resp?.success) ? 	
							resp && resp.msg && <div>
									<div style={styles.error}>{resp?.msg}</div>
									<div style={{textAlign:'center'}}>
										<span>
											<Link to='/forgot-password'>Resend Password Reset Link</Link>
										</span>
									</div>
								</div>
							:
							<Spin size='large' />
						}
					</Card>
				</Col>
			</Background>
    );
};

export default ResetExpireError;
const StyledComponents = {
	Background: styled(Row)`
		height: 100vh;
		background-image: url(${loginBG});
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
	`,
	SubmitButton: styled(Button)``,
};